"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.BmDateInputInfoFactory = exports.BmDateInputFieldInfo = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _inputFactory = require("../../../../core/render/items/input-engine/input-factory");

var BmDateInputFieldInfo = /*#__PURE__*/function (_BmInputInfo) {
  (0, _inherits2.default)(BmDateInputFieldInfo, _BmInputInfo);

  var _super = (0, _createSuper2.default)(BmDateInputFieldInfo);

  function BmDateInputFieldInfo(info, parent, value) {
    var _this;

    (0, _classCallCheck2.default)(this, BmDateInputFieldInfo);
    _this = _super.call(this, info, parent, value);
    _this.type = 'date-input-field';
    _this.options = info.options;
    return _this;
  }

  return BmDateInputFieldInfo;
}(_inputFactory.BmInputInfo);

exports.BmDateInputFieldInfo = BmDateInputFieldInfo;

var BmDateInputInfoFactory = function BmDateInputInfoFactory(info, parent, _, value) {
  return new BmDateInputFieldInfo(info, parent, value);
};

exports.BmDateInputInfoFactory = BmDateInputInfoFactory;
